import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as evaluationPlayerAPI from 'api/Evalution';

const initialState = {
  status: '',
  data: null,
  featuresData: [],
  EvaluationPlayerConfigData: null,
  section_config: {
    ScoreBar: {
      analytics: {
        data: [
          {
            title: 'Agent',
            type: 'string',
            key: 'call_info_agent',
            divider: true
          },
          {
            title: 'Call ID',
            type: 'string',
            key: 'call_info_call_id',
            divider: true
          },
          {
            title: 'CQ Score',
            type: 'number',
            key: 'call_info_cq_score',
            divider: true
          },
          {
            title: 'CSAT Score',
            type: 'number',
            key: 'call_info_csat_score'
          }
        ],
        visiblity: true
      },
      toggle: {
        visiblity: true
      }
    },

    Transcript: {
      data: [
        { title: 'Agent', key: 'agent', color: '#3E97FF' },
        { title: 'Customer', key: 'customer', color: '#64748B' }
        // { title: '', key: 'none', color: '#FF0000' }
      ],
      visiblity: true
    },
    ConversationRecording: {}
  },
  ui: {
    loading: false
  },
  formData: null,
  formDataRes: null,
  FormTabName: null,
  transcriptSearchData: null,
  error: null
};
const getEvaluationPlayer = (state) => state.evaluationPlayer;

const getEvaluationPlayerConfigData = createAsyncThunk('evaluationPlayer/getEvaluationPlayerConfigData', async (_, { rejectWithValue }) => {
  try {
    const res = await evaluationPlayerAPI.getEvaluationPlayerConfigData();
    return res?.data?.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const getEvaluationPlayerData = createAsyncThunk(
  'evaluationPlayer/getEvaluationPlayerData',
  async ({ params, signal }, { rejectWithValue }) => {
    try {
      console.log('params', params);
      const res = await evaluationPlayerAPI.getEvaluationPlayerData(params, signal);
      return res?.data?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getEvaluationFormData = createAsyncThunk('evaluationPlayer/getEvaluationFormData', async ({ id, signal }, { rejectWithValue }) => {
  try {
    const res = await evaluationPlayerAPI.getEvaluationFormData(id, signal);
    return res?.data?.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const createEvaluationFormData = createAsyncThunk('evaluationPlayer/createEvaluationFormData', async (params, { rejectWithValue }) => {
  try {
    const res = await evaluationPlayerAPI.createEvaluationFormData(params);
    return res?.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const getTranscriptSearchData = createAsyncThunk('evaluationPlayer/transcriptSearchData', async (params, { rejectWithValue }) => {
  try {
    const res = await evaluationPlayerAPI.getTranscriptSearchData(params);
    return res?.data?.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const evaluationPlayerSlice = createSlice({
  name: 'evaluationPlayer',
  initialState: initialState,

  reducers: {
    resetState: () => {
      return initialState;
    },
    SelectedFormTabName: (state, action) => {
      state.FormTabName = action.payload;
    },
    handleSetFormFieldData: (state, action) => {
      const index = state.formData.form_data.findIndex((ele) => ele.id === action.payload.filter_type);
      if (index !== -1) state.formData.form_data[index].answer = action.payload.value;
    },
    handleRemoveFormFieldData: (state, action) => {
      const index = state.formData.form_data.findIndex((ele) => ele.id === action.payload.filter_type);
      if (index !== -1) state.formData.form_data[index].answer = null;
    },

    handleSetMultipleFormFieldData: (state, action) => {
      const selectedIdx = state.formData.form_data.findIndex((ele) => ele.id === action.payload.filter_type);
      if (Array.isArray(state.formData.form_data[selectedIdx].answer)) {
        if (state.formData.form_data[selectedIdx].answer.includes(action.payload.value)) {
          const prevData = state.formData.form_data[selectedIdx].answer;
          var index = prevData.indexOf(action.payload.value);
          if (index !== -1) {
            prevData.splice(index, 1);
          }
        } else {
          state.formData.form_data[selectedIdx].answer.push(action.payload.value);
        }
      } else state.formData.form_data[selectedIdx].answer = [action.payload.value];
    },
    handleRemoveMultipleFormFieldData: (state, action) => {
      const selectedIdx = state.formData.form_data.findIndex((ele) => ele.id === action.payload.filter_type);
      const prevData = state.formData.form_data[selectedIdx].answer;
      var index = prevData.indexOf(action.payload.value);
      if (index !== -1) {
        prevData.splice(index, 1);
      }
    },
    removeTranscriptSearchData: (state) => {
      state.transcriptSearchData = null;
    }
  },

  extraReducers: {
    [getEvaluationPlayerConfigData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getEvaluationPlayerConfigData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.EvaluationPlayerConfigData = action.payload;
    },
    [getEvaluationPlayerConfigData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getEvaluationPlayerData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getEvaluationPlayerData.fulfilled]: (state, action) => {
      console.log('action from the api', action.payload);
      state.status = 'idle';
      state.ui.loading = false;
      state.data = action.payload;
      const categoryData = action.payload?.cq_score_part?.value?.cq_score_count;
      let features = [];
      categoryData.map((_el) => {
        features = [...features, ..._el.features];
      });
      state.featuresData = features;
    },
    [getEvaluationPlayerData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getEvaluationFormData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getEvaluationFormData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.formData = action.payload;
    },
    [getEvaluationFormData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [createEvaluationFormData.pending]: (state) => {
      state.status = 'init';
      state.formDataRes = null;
      state.ui.loading = true;
    },
    [createEvaluationFormData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.formDataRes = action.payload;
      state.ui.loading = false;
    },
    [createEvaluationFormData.rejected]: (state, action) => {
      state.status = 'error';
      state.formDataRes = action.payload;
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getTranscriptSearchData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getTranscriptSearchData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.transcriptSearchData = action.payload;
      state.ui.loading = false;
    },
    [getTranscriptSearchData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }
  }
});

const {
  resetState,
  handleSetFormFieldData,
  handleRemoveFormFieldData,
  handleSetMultipleFormFieldData,
  handleRemoveMultipleFormFieldData,
  SelectedFormTabName,
  removeTranscriptSearchData
} = evaluationPlayerSlice.actions;

export default evaluationPlayerSlice.reducer;

export {
  resetState,
  getEvaluationPlayer,
  getEvaluationPlayerConfigData,
  getEvaluationPlayerData,
  getEvaluationFormData,
  handleSetFormFieldData,
  handleRemoveFormFieldData,
  handleSetMultipleFormFieldData,
  handleRemoveMultipleFormFieldData,
  SelectedFormTabName,
  createEvaluationFormData,
  getTranscriptSearchData,
  removeTranscriptSearchData
};
